import { useEffect, useState } from 'react';
import { api } from '../api/client';

const STATUS = {
  SUBMITTED: ['navy', 'Soumis'],
  APPROVED: ['green', 'Approuvé'],
  REJECTED: ['red', 'Refusé'],
  CANCELLED: ['gray', 'Annulé'],
};

const LEAVE_TYPES = [
  { value: 'ANNUAL', label: 'Congés annuels' },
  { value: 'SICK', label: 'Maladie' },
  { value: 'UNPAID', label: 'Sans solde' },
  { value: 'MATERNITY', label: 'Maternité / Paternité' },
  { value: 'EXCEPTIONAL', label: 'Congé exceptionnel' },
  { value: 'BEREAVEMENT', label: 'Deuil' },
];

const d = (v) => v ? new Date(v).toLocaleDateString('fr-FR') : '—';

export default function Conges() {
  const [tab, setTab] = useState('demandes');
  return (
    <>
      <div className="tabs" style={{ marginBottom: 4 }}>
        <button className={`tab ${tab === 'demandes' ? 'active' : ''}`} onClick={() => setTab('demandes')}>Demandes</button>
        <button className={`tab ${tab === 'approuver' ? 'active' : ''}`} onClick={() => setTab('approuver')}>À approuver</button>
        <button className={`tab ${tab === 'soldes' ? 'active' : ''}`} onClick={() => setTab('soldes')}>Soldes</button>
      </div>
      {tab === 'demandes' && <ListeDemandes />}
      {tab === 'approuver' && <ApprobationDemandes />}
      {tab === 'soldes' && <SoldesConges />}
    </>
  );
}

function ListeDemandes() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  const [contracts, setContracts] = useState([]);

  function load() {
    api.get('/hr/leave-requests').then((data) => setRows(data || [])).catch((e) => setError(e.message));
  }

  useEffect(() => {
    load();
    api.get('/hr/contracts?status=ACTIVE').then((data) => setContracts(data || [])).catch(() => {});
  }, []);

  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Demandes de congés</h2>
        <button className="btn btn-sm" onClick={() => setModal({})}>+ Nouvelle demande</button>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {rows.length === 0 ? <div className="empty">Aucune demande.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr>
                <th>Agent</th><th>Matricule</th><th>Type</th>
                <th>Du</th><th>Au</th><th>Jours</th>
                <th>Motif</th><th>Statut</th><th>Approuvé par</th>
              </tr>
            </thead>
            <tbody>{rows.map((r) => {
              const [bc, bl] = STATUS[r.status] || ['gray', r.status];
              return (
                <tr key={r.id}>
                  <td><b>{r.lastName || r.last_name} {r.firstName || r.first_name}</b></td>
                  <td className="mono">{r.matricule || '—'}</td>
                  <td>{LEAVE_TYPES.find((t) => t.value === r.leaveType)?.label || r.leaveType || '—'}</td>
                  <td className="mono">{d(r.startDate || r.start_date)}</td>
                  <td className="mono">{d(r.endDate || r.end_date)}</td>
                  <td className="num">{r.durationDays || r.duration_days || '—'}</td>
                  <td>{r.reason || '—'}</td>
                  <td><span className={`badge ${bc}`}>{bl}</span></td>
                  <td>{r.approverEmail || r.approverFirstName || '—'}</td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
      {modal && (
        <DemandeModal
          initial={modal}
          contracts={contracts}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </div>
  );
}

function ApprobationDemandes() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  function load() {
    api.get('/hr/leave-requests?status=SUBMITTED').then((data) => setRows(data || [])).catch((e) => setError(e.message));
  }

  useEffect(load, []);

  async function approve(id) {
    try { await api.post(`/hr/leave-requests/${id}/approve`); load(); } catch (e) { setError(e.message); }
  }

  async function reject(id) {
    const reason = prompt('Motif du refus :');
    if (!reason) return;
    try { await api.post(`/hr/leave-requests/${id}/reject`, { rejectionReason: reason }); load(); } catch (e) { setError(e.message); }
  }

  return (
    <div className="panel">
      <div className="panel-head"><h2>Demandes à approuver</h2><span className="badge navy">{rows.length}</span></div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {rows.length === 0 ? <div className="empty">Aucune demande en attente.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr><th>Agent</th><th>Type</th><th>Du</th><th>Au</th><th>Jours</th><th>Motif</th><th></th></tr>
            </thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id}>
                <td><b>{r.lastName || r.last_name} {r.firstName || r.first_name}</b><br /><small className="mono">{r.matricule}</small></td>
                <td>{LEAVE_TYPES.find((t) => t.value === r.leaveType)?.label || r.leaveType || '—'}</td>
                <td className="mono">{d(r.startDate || r.start_date)}</td>
                <td className="mono">{d(r.endDate || r.end_date)}</td>
                <td className="num">{r.durationDays || r.duration_days}</td>
                <td>{r.reason || '—'}</td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button className="btn btn-sm" style={{ background: 'var(--success)', marginRight: 6 }} onClick={() => approve(r.id)}>✓ Approuver</button>
                  <button className="link-danger" style={{ fontSize: '0.75rem' }} onClick={() => reject(r.id)}>✕ Refuser</button>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}

function SoldesConges() {
  const [contracts, setContracts] = useState([]);
  const [balances, setBalances] = useState({});
  const [year, setYear] = useState(new Date().getFullYear());
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/hr/contracts?status=ACTIVE').then(async (data) => {
      setContracts(data || []);
      const all = {};
      for (const c of (data || [])) {
        try {
          const b = await api.get(`/hr/leave-balance/${c.id}?year=${year}`);
          all[c.id] = b || [];
        } catch {}
      }
      setBalances(all);
    }).catch((e) => setError(e.message));
  }, [year]);

  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Soldes de congés</h2>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <label>Année</label>
          <input type="number" value={year} onChange={(e) => setYear(Number(e.target.value))} style={{ width: 90 }} />
        </div>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {contracts.length === 0 ? <div className="empty">Aucun contrat actif.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr><th>Agent</th><th>Poste</th><th>Type de congé</th><th>Alloué</th><th>Pris</th><th>Restant</th></tr>
            </thead>
            <tbody>
              {contracts.map((c) => {
                const bals = balances[c.id] || [];
                if (bals.length === 0) {
                  return (
                    <tr key={c.id}>
                      <td><b>{c.lastName} {c.firstName}</b><br /><small className="mono">{c.matricule}</small></td>
                      <td>{c.position}</td>
                      <td colSpan={4} style={{ color: 'var(--muted)', fontStyle: 'italic' }}>Aucun solde enregistré</td>
                    </tr>
                  );
                }
                return bals.map((b, i) => (
                  <tr key={`${c.id}-${i}`}>
                    {i === 0 && (
                      <>
                        <td rowSpan={bals.length}><b>{c.lastName} {c.firstName}</b><br /><small className="mono">{c.matricule}</small></td>
                        <td rowSpan={bals.length}>{c.position}</td>
                      </>
                    )}
                    <td>{b.leaveType || '—'}</td>
                    <td className="num">{b.entitled ?? '—'}</td>
                    <td className="num">{b.taken ?? 0}</td>
                    <td className="num"><b>{b.remaining ?? '—'}</b></td>
                  </tr>
                ));
              })}
            </tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}

function DemandeModal({ initial, contracts, onClose, onSaved }) {
  const [form, setForm] = useState({
    contractId: '',
    leaveType: '',
    startDate: '',
    endDate: '',
    reason: '',
    documentUrl: '',
  });
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    api.get('/hr/leave-types').then((data) => setLeaveTypes(data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (form.startDate && form.endDate && form.endDate >= form.startDate) {
      const start = new Date(form.startDate);
      const end = new Date(form.endDate);
      let count = 0;
      const cur = new Date(start);
      while (cur <= end) {
        const day = cur.getDay();
        if (day !== 0 && day !== 6) count++;
        cur.setDate(cur.getDate() + 1);
      }
      setDuration(count);
    } else {
      setDuration(null);
    }
  }, [form.startDate, form.endDate]);

  async function save() {
    if (!form.contractId || !form.leaveType || !form.startDate || !form.endDate) {
      setError('Tous les champs obligatoires doivent être remplis.');
      return;
    }
    if (form.endDate < form.startDate) {
      setError('La date de fin doit être postérieure à la date de début.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/hr/leave-requests', form);
      onSaved();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Nouvelle demande de congé</h2>
        {error && <div className="form-error">{error}</div>}

        <div className="field">
          <label>Agent (contrat actif) *</label>
          <select value={form.contractId} onChange={(e) => setForm({ ...form, contractId: e.target.value })}>
            <option value="">Sélectionner…</option>
            {contracts.map((c) => (
              <option key={c.id} value={c.id}>{c.lastName} {c.firstName} — {c.position}</option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>Type de congé *</label>
          <select value={form.leaveType} onChange={(e) => setForm({ ...form, leaveType: e.target.value })}>
            <option value="">Sélectionner…</option>
            {leaveTypes.length > 0
              ? leaveTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)
              : LEAVE_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)
            }
          </select>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div className="field">
            <label>Date de début *</label>
            <input type="date" value={form.startDate} onChange={(e) => setForm({ ...form, startDate: e.target.value })} />
          </div>
          <div className="field">
            <label>Date de fin *</label>
            <input type="date" value={form.endDate} onChange={(e) => setForm({ ...form, endDate: e.target.value })} />
          </div>
        </div>

        {duration && (
          <div style={{ padding: '6px 10px', background: 'var(--info-bg, #e8f4fd)', borderRadius: 6, marginBottom: 8, fontSize: '0.875rem' }}>
            Durée : <b>{duration} jour ouvré{duration > 1 ? 's' : ''}</b> (lun-ven)
          </div>
        )}

        <div className="field">
          <label>Motif</label>
          <textarea value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} rows={3} />
        </div>

        <div className="field">
          <label>Pièce justificative (URL)</label>
          <input type="text" value={form.documentUrl} onChange={(e) => setForm({ ...form, documentUrl: e.target.value })} placeholder="Lien vers le document..." />
        </div>

        <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
          <button className="btn" onClick={save} disabled={saving}>{saving ? 'Soumission…' : 'Soumettre'}</button>
        </div>
      </div>
    </div>
  );
}
